import React from 'react';

/**
 * Overlay component that wraps children with a skeleton loading animation
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child elements to be wrapped
 * @param {boolean} props.active - Whether the overlay animation is active
 * @param {...Object} props - Additional props passed to the container div
 * @returns {React.ReactElement} Overlay component with skeleton animation
 */
const Overlay = ( { children, ...props } ) => {
    const active = props.active;
    return (
        <div className={ active ? 'ant-skeleton overlay-container active' : 'ant-skeleton overlay-container' } { ...props } >
            { children }
            <div className="overlay-animation">
            </div>
        </div>
    );
};

export { Overlay };
